<template>
    <div class="relative flex flex-col h-screen">
        <img :src="getImage('mascot')" class="fixed papsi-mascot">
        <div class="flex flex-1 lg:flex-row flex-col">
            <SidebarSection>
                <div class="flex flex-col">
                    <LabelControl type="message" :content="$t('bip001')" />
                </div>
            </SidebarSection>
            <ContentSection @logout="logout">

                <div class="flex flex-row items-center justify-between mb-10">
                    <LabelControl v-if="deposit_type == 'loans'" content="Loans Menu"></LabelControl>
                    <LabelControl v-else content="Savings Deposit Menu"></LabelControl>
                    <div class="justify-end align-middle papsi-toggle">
                        <div @click="this.hideAllBalances" v-if="!this.hide_all_balances" class="flex flex-row bg-grey rounded-full px-6 py-3 justify-end w-auto">
                            <p class="text-2xl text-white ">{{ $t('led014') }}</p>
                            <img :src="getIcon('hide')" class="ml-2">
                        </div>
                        <div @click="this.showAllBalances" v-else class="flex flex-row bg-primary rounded-full px-6 py-3 justify-end w-auto">
                            <p class="text-2xl text-white">{{ $t('led015') }}</p>
                            <img :src="getIcon('show')" class="ml-2">
                        </div>
                    </div>
                </div>

                <div class="flex flex-col w-full overflow-y-auto pr-5 papsi-height papsi-text">
                    <div v-if="deposit_type == 'loans'">
                        <MenuControl v-for="type in getLoansTypes" class="mb-5" :key="type.code" :code="type.code"
                            :type="this.deposit_type" :title="type.name"
                            :balance="this.formatAmount(this.getBalancesByCode(type.code))" :hide_balance="this.hide_all_balances" />
                        <MenuControl background_color="#E6E7EB" :is_disabled="true" v-for="type in getInvalidLoanTypes"
                            class="mb-5" :key="type.code" :code="type.code" :type="this.deposit_type" :title="type.name"
                            :balance="this.formatAmount(this.getBalancesByCode(type.code))" :hide_balance="this.hide_all_balances" />
                    </div>
                    <div v-else>
                        <MenuControl v-for="type in getSavingsTypes" class="mb-5" :key="type.code" :code="type.code"
                            :type="this.deposit_type" :title="type.name"
                            :balance="this.formatAmount(this.getBalancesByCode(type.code))" :hide_balance="this.hide_all_balances" />
                            <!-- <MenuControl class="mb-5" code="" type="RSD" title="GROUP SAVINGS DEPOSIT" balance="20,000" :hide_balance="this.hide_all_balances" />
                        <MenuControl class="mb-5" code="" type="RSD" title="SMILE" balance="40,000" :hide_balance="this.hide_all_balances" /> -->
                    </div>
                </div>
            </ContentSection>
        </div>
        <FooterSection />
    </div>
</template>

<script>
import SidebarSection from '@/components/sections/SidebarSection.vue';
import ContentSection from '@/components/sections/ContentSection.vue';
import FooterSection from '@/components/sections/FooterSection.vue';
import LabelControl from '@/components/controls/LabelControl.vue';
import MenuControl from '@/components/controls/MenuControl.vue';
import mixin from '@/mixins/controls.js';
import user from '@/services/user';

export default {
    mixins: [mixin],
    inject: ['setLoading', 'setError'],
    components: {
        SidebarSection,
        ContentSection,
        FooterSection,
        LabelControl,
        MenuControl,
    },
    computed: {
        getSavingsTypes() {
            return this.$store.state.ledgers.types.filter(item => !item.is_loan && item.code !== "SHR").sort((a, b) => a.name.localeCompare(b.name));
        },
        getLoansTypes() {

            const ongoing_loans = this.$store.state.ledgers.types
                .filter(item => item.is_loan && item.code !== "SHR" && this.getBalancesByCode(item.code) > 0)
                .sort((a, b) => this.getBalancesByCode(b.code) - this.getBalancesByCode(a.code));

            const completed_loans = this.$store.state.ledgers.types
                .filter(item => item.is_loan && item.code !== "SHR" && this.getRecordsByCode(item.code) > 0 && this.getBalancesByCode(item.code) <= 0)
                .sort((a, b) => a.name.localeCompare(b.name));

            return [...ongoing_loans, ...completed_loans];
        },
        getInvalidLoanTypes() {
            return this.$store.state.ledgers.types
                .filter(item => item.is_loan && item.code !== "SHR" && this.getRecordsByCode(item.code) == 0)
                .sort((a, b) => a.name.localeCompare(b.name));
        }
    },
    data() {
        return {
            deposit_type: this.$route.params.type,
            hide_all_balances: true,
            hash: this.$store.state.user.hash,
            uuid: this.$store.state.user.uuid,
            balance_ref: this.$store.state.user.balance_ref,
            balance_delay: parseInt(process.env.VUE_APP_BALANCE_FETCH_DELAY, 10),
        }
    },
    mounted() {
        this.$emit('checkauth');
        // this.retrieveBalances();
        // if (this.checkInvalidBalance()) {
        //     if (this.$store.state.user.hash) {
        //         this.showError('Failed to retrieve balances. Please log in again.');
        //         this.logout();
        //     }
        // }
    },
    methods: {
        logout() {
            this.$emit('logout');
        },
        getBalancesByCode(code) {
            const item = this.$store.state.user.ledgers.find(item => item.code === code);
            return item ? item.balance : null;
        },
        getRecordsByCode(code) {
            const item = this.$store.state.user.ledgers.find(item => item.code === code);
            return item ? item.records : null;
        },
        checkInvalidBalance() {
            const balances = this.deposit_type === 'loans'
                ? this.getLoansTypes.map(type => parseFloat(this.getBalancesByCode(type.code)))
                : this.getSavingsTypes.map(type => parseFloat(this.getBalancesByCode(type.code)));
            return balances.some(balance => isNaN(balance));
        },
        hideAllBalances() {
            this.hide_all_balances = true;
        },
        showAllBalances() {
            this.hide_all_balances = false;
        },
        retrieveBalances() {
            const ledgers = this.$store.state.user.ledgers;
            if (ledgers.length > 0) {
                // this.$router.push({ name: 'balance-inquiry-page' });
                return;
            }
            this.setLoading(true);
            user.fetchBalances(this.hash, this.uuid, this.balance_ref).then((response) => {
                const balances = response.data.data;
                Object.entries(balances).forEach(([code, {total_balance, total_records, as_of }]) => {
                    this.$store.commit('addBalance', { code: code, balance: total_balance, records: total_records, as_of: as_of });
                });
                this.$router.push({ name: 'balance-inquiry-page' });
                this.setLoading(false);
            }).catch((error) => {
                if (error.response && error.response.status === 403) {
                    this.setLoading(false);
                    this.$router.push({ name: 'services-page', query: { existing_session: true } });
                }
                else if (error.response && error.response.status === 417) {
                    // let timer = setTimeout(() => {
                    //     this.retrieveBalances();
                    //     clearTimeout(timer);
                    // }, this.balance_delay);
                }
                this.$router.push({ name: "login-page" }); 
            });
        },
    },
};
</script>

<style scoped>
.papsi-mascot {
    bottom: 0;
    left: 0;
    width: 25rem;
}

.papsi-height {
    height: 38rem;
}

.cards-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 1rem;
    row-gap: 1px;
}

@media (min-width: 2500px) {
  .toggle {
    width:  27rem !important;
  }
  .ml-2 {
    margin-left: 1rem !important;
    width: 3rem !important;
    height: 3rem !important;
  }
}
</style>
